import { startAppListening } from '@app/store/listenerMiddleware';
import { getAnalytics } from '@services/analytics';
import { baseApi } from '@services/api/baseApi';
import { getReporter } from '@services/monitoring';

import { authFailed, authSucceeded, loggedOut } from './authSlice';

// Reset RTK Query cache and clear monitoring + analytics identity on logout
// (or any auth failure). We dispatch reporter / analytics calls instead of
// importing them at the call site so consumers don't need to know which
// SDKs are wired in.
startAppListening({
  matcher: (action) => loggedOut.match(action) || authFailed.match(action),
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
    getReporter().setUser(null);
    getAnalytics().identify(null);
  },
});

// Attach user identity to monitoring + analytics events once authenticated.
startAppListening({
  matcher: authSucceeded.match,
  effect: (action) => {
    getReporter().setUser({ id: action.payload.id, email: action.payload.email });
    getAnalytics().identify({ id: action.payload.id, email: action.payload.email });
  },
});
